//event type
export const QUESTIONNAIRE_CHAT_ID = 'questionnaire-chatId'
export const QUESTIONNAIRE_CLOSE_IFRAME = 'questionnaire-close_iframe'
export const OPPORTUNITY_TO_RETURN = 'opportunityToReturn'
export const QUESTIONNAIRE_IFRAME_STATE = 'questionnaire-iframe-state'
export const QUESTIONNAIRE_CLOSE_IFRAME_SUCCESSFULLY = 'questionnaire-close_iframe_successfully'
export const QUESTIONNAIRE_DISABLE_BUTTON = 'questionnaire-disable-button'
export const QUESTIONNAIRE_FULLSCREEN_IMAGE = 'questionnaire-fullscreen-image'
export const QUESTIONNAIRE_OPEN_ACCORDION = 'questionnaire-open-accordion'
export const QUESTIONNAIRE_CONTENT_LOADED = 'questionnaire-content-loaded'
export const QUESTIONNAIRE_SWITCH_LANGUAGE = 'questionnaire-switch-language'

//event name
export const BIG_IMAGE = 'bigImage'
export const OPEN_WEBVIEW = 'openWebview'
export const CLOSE = 'close'
